import React, { useState } from 'react';
import type { ButtonCustomization } from '../../lib/types';

interface ButtonConfiguratorProps {
  onConfigChange: (config: ButtonCustomization) => void;
}

const ButtonConfigurator: React.FC<ButtonConfiguratorProps> = ({ onConfigChange }) => {
  const [config, setConfig] = useState<ButtonCustomization>({
    text: 'Partner with Us',
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    showIcon: false,
    position: 'bottom-right',
    fontSize: '0.875rem',
    padding: '0.75rem 1.5rem',
    borderRadius: '0.25rem',
    borderColor: '#E5E7EB',
  });

  const handleChange = (key: keyof ButtonCustomization, value: any) => {
    const newConfig = { ...config, [key]: value };
    setConfig(newConfig);
    onConfigChange(newConfig);
  };

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Button Text
            </label>
            <input
              type="text"
              value={config.text}
              onChange={(e) => handleChange('text', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Background Color
            </label>
            <div className="flex gap-2">
              <input
                type="color"
                value={config.backgroundColor}
                onChange={(e) => handleChange('backgroundColor', e.target.value)}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={config.backgroundColor}
                onChange={(e) => handleChange('backgroundColor', e.target.value)}
                className="flex-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Text Color
            </label>
            <div className="flex gap-2">
              <input
                type="color"
                value={config.textColor}
                onChange={(e) => handleChange('textColor', e.target.value)}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={config.textColor}
                onChange={(e) => handleChange('textColor', e.target.value)}
                className="flex-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Border Color
            </label>
            <div className="flex gap-2">
              <input
                type="color"
                value={config.borderColor}
                onChange={(e) => handleChange('borderColor', e.target.value)}
                className="h-10 w-20"
              />
              <input
                type="text"
                value={config.borderColor}
                onChange={(e) => handleChange('borderColor', e.target.value)}
                className="flex-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
              />
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Position
            </label>
            <select
              value={config.position}
              onChange={(e) => handleChange('position', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
            >
              <option value="bottom-right">Bottom Right</option>
              <option value="bottom-left">Bottom Left</option>
              <option value="top-right">Top Right</option>
              <option value="top-left">Top Left</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Border Radius
            </label>
            <select
              value={config.borderRadius}
              onChange={(e) => handleChange('borderRadius', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
            >
              <option value="0">None</option>
              <option value="0.25rem">Small</option>
              <option value="0.5rem">Medium</option>
              <option value="9999px">Fully Rounded</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Padding
            </label>
            <select
              value={config.padding}
              onChange={(e) => handleChange('padding', e.target.value)}
              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-gray-200"
            >
              <option value="0.5rem 1rem">Small</option>
              <option value="0.75rem 1.5rem">Medium</option>
              <option value="1rem 2rem">Large</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonConfigurator;